import { type FC } from 'react';
import {
  NumberInShapeComponent, Shape, type SharedNumberProps,
} from '~/_shared/baseComponents/numberInShape/numberInShape.component';

export const NumberInCircleComponent: FC<SharedNumberProps> = ({ children, ...rest }) => (
  <NumberInShapeComponent
    {...rest}
    shape={Shape.circle}
  >
    {children}
  </NumberInShapeComponent>
);
